import React from 'react'

export default function PageNoteFound() {
  return (
    <div>PageNoteFound</div>
  )
}
